<template>
    <v-row class="mx-1">
        <ViewAttendee v-model="viewAttendeeDialog" :attendee="selectedAttendee"></ViewAttendee>

        <v-col cols="12" class="d-flex justify-end align-center">
            <div class="d-flex flex-wrap">
                <v-btn color="kbPurple"
                       class="mr-2"
                       outlined
                       text
                       @click="showImporterAttendeesDialog()">
                    {{$t('general.importAssistants')}}
                </v-btn>

                <v-btn color="kbPurple"
                       dark
                       @click="newAttendee()">{{$t('general.registerAttender')}}</v-btn>
            </div>
        </v-col>

        <v-col cols="12" sm="6">
            <v-select :label="$t('general.event')"
                      color="kbDarkBlue"
                      :items="events"
                      item-text="title"
                      item-value="_id"
                      @change="getAttendees()"
                      v-model="selectedEvent">
            </v-select>
        </v-col>
        <v-col cols="12" sm="6">
            <v-text-field
                color="kbDarkBlue"
                v-model="search"
                append-icon="search"
                :placeholder="$t('general.search')"
                single-line
                hide-details
                clearable>
                <template slot="append-outer">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on"
                                    color="kbDarkBlue"
                                    small
                                    class="ml-2"
                                    @click="showAdvancedOptions = !showAdvancedOptions">fas fa-sliders-h</v-icon>
                        </template>
                        <span>{{$t('general.advancedSearch')}}</span>
                    </v-tooltip>
                    <v-icon class="ml-2"
                            color="kbDarkBlue"
                            @click="getAttendees">refresh</v-icon>
                </template>
            </v-text-field>
        </v-col>

        <v-col cols="12" class="text-h6">
            <!--<v-expand-transition>-->
            <!--<v-container fluid grid-list-md v-if="showAdvancedOptions">-->
            <!--<v-form ref="advancedSearch" @submit.prevent>-->
            <!--<v-layout v-row wrap>-->
            <!--<v-flex xs12>-->
            <!--Búsqueda avanzada-->
            <!--</v-flex>-->

            <!--<v-flex xs12>-->
            <!--<v-text-field label="Identificación"-->
            <!--v-model="advancedSearch.identification">-->
            <!--</v-text-field>-->
            <!--</v-flex>-->
            <!--</v-layout>-->
            <!--</v-form>-->
            <!--</v-container>-->
            <!--</v-expand-transition>-->

            <v-data-table :headers="headers"
                          :items="attendees"
                          class="elevation-2"
                          :loading="loadingAttendees"
                          :options.sync="options"
                          :footer-props="{
                        'items-per-page-text': $t('general.assistantsPerPage'),
                        'items-per-page-options': [50, 100, 200]
                      }"
                          :server-items-length="totalAttendees">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="font-weight-bold text-capitalize">{{ item.name || $t('general.noName')}}</td>
                        <td>{{ item.email || item.phone.join(', ') }}</td>
                        <td>{{ item.ticket.title }}</td>
                        <td>{{ item.manualCreation ? $t('general.manual') : $t('general.automatic') }}</td>
                        <td>{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mma') }}</td>
                        <td class="px-0 mx-0">
                            <div class="data-table-actions d-flex justify-center align-center">
                                <v-btn icon @click="showUser(item)" color="kbDarkBlue" text>
                                    <v-icon>remove_red_eye</v-icon>
                                </v-btn>

                                <a style="text-decoration: none" v-if="item.urlDownload.url" :href="item.urlDownload.url" target="_blank">
                                    <v-btn icon color="kbDarkBlue" text>
                                        <v-icon>fas fa-qrcode</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingAttendees">
                            {{$t('general.loadingAssistants')}}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{$t('general.noAssistantsRegistered')}}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import TimeZones from '@/mixins/TimeZones'
import ViewAttendee from '@/pages/App/Attendees/dialogs/ViewAttendee.vue'
export default {
  components: { ViewAttendee },
  computed: {
    ...mapState({
      advancedSearch: state => state.attendees.advancedSearch,
      loadingAttendees: state => state.attendees.loadingAttendees,
      paginationAttendees: state => state.attendees.paginationAttendees,
      selectedApp: state => state.apps.selectedApp,
      totalAttendees: state => state.attendees.totalAttendees,
      attendees: state => state.attendees.attendees,
      events: state => state.events.events
    }),
    search: {
      get () {
        return this.$store.state.attendees.search
      },
      set (value) {
        this.$store.commit('SET_SEARCH_ATTENDEES', value)
      }
    },
    headers () {
      return [
        { text: this.$t('general.assistantName'), value: 'name' },
        { text: `${this.$t('general.email')} / ${this.$t('general.phone')}`, value: 'email' },
        { text: this.$t('general.ticket'), value: 'ticket' },
        { text: this.$t('general.creation'), value: 'manualCreation' },
        { text: this.$t('general.registerDate'), value: 'createdAt' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      options: {
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      selectedAttendee: null,
      showAdvancedOptions: false,
      viewAttendeeDialog: false,
      selectedEvent: ''
    }
  },
  methods: {
    getAttendees () {
      this.advancedSearch.eventId = this.selectedEvent
      this.$store.commit('SET_PAGINATION_ATTENDEES', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getAttendees')
    },
    viewEvent (event) {
      this.$emit('viewEvent', event)
    },
    newAttendee () {
      this.$emit('newAttendee')
    },
    showImporterAttendeesDialog () {
      this.$emit('showImporterAttendeesDialog')
    },
    showNewEditEvent (event) {
      this.$emit('showNewEditEvent', event)
    },
    showUser (user) {
      this.selectedAttendee = user
      this.viewAttendeeDialog = true
    }
  },
  mixins: [TimeZones],
  watch: {
    events (value) {
      if (value.length > 0) {
        this.advancedSearch.eventId = value[0]._id
      }
    },
    options: {
      handler () {
        this.getAttendees()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.getAttendees()
    },
    selectedApp () {
      this.$store.dispatch('getEvents')
    }
  }
}
</script>
